import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CheckinsService } from '@/shared/api/rest/services/checkins.service'
import { useAlertService } from '@/shared/lib/useAlertService'

export const useClearQueue = () => {
    const alertService = useAlertService()
    const queryClient = useQueryClient()

    const { mutateAsync, isPending } = useMutation({
        mutationFn: (branchId: string) => CheckinsService.clearQueue(branchId),
        onSuccess: () => {
            alertService.success('Queue cleared successfully')
            queryClient.invalidateQueries({ queryKey: ['checkout-queue'] })
            queryClient.invalidateQueries({ queryKey: ['checkout-queue-sub'] })
        },
        onError: (error: Error) => {
            alertService.error(error.message)
        }
    })

    const handleClearQueue = async (branchId: string) => {
        if (!branchId) return
        await mutateAsync(branchId)
    }

    return {
        clearQueue: handleClearQueue,
        clearing: isPending
    }
}
